module.exports = __webpack_public_path__ + "/login_ui/img/md-84cf3d94b61dd3274e0b9c7e49f988a0.svg";